// API Service for all dealer and office operations
const API_BASE_URL = "https://alcobrakeadmin.com/v3/us";

export const dealerAPI = {
  // Fetch all dealers (streaming NDJSON)
  fetchDealers: async (onData) => {
    const url = `${API_BASE_URL}/cadealers/getalldealerss`;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";

      while (true) {
        const { done, value } = await reader.read();
        
        if (done) {
          if (buffer.trim()) {
            try {
              const dealer = JSON.parse(buffer);
              onData(dealer);
            } catch (err) {}
          }
          break;
        }

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split("\n");
        buffer = lines.pop() || "";
        
        for (const line of lines) {
          if (!line.trim()) continue;
          try {
            const dealer = JSON.parse(line);
            onData(dealer);
          } catch (err) {}
        }
      }
    } catch (error) {
      console.error("Error fetching dealers:", error);
      throw error;
    }
  },

  // Add new dealer (using FormData)
  addDealer: async (dealerData) => {
    const url = `${API_BASE_URL}/cadealers/adddealer`;
    console.log("Adding dealer to URL:", url);
    
    const formData = new FormData();
    formData.append("dealerName", dealerData.dealerName);
    formData.append("dealerEmail", dealerData.dealerEmail);
    formData.append("dealerMobile1", dealerData.dealerMobile1);
    formData.append("dealerMobile2", dealerData.dealerMobile2 || '');
    formData.append("dealerPassword", dealerData.dealerPassword);
    formData.append("accesslevel", dealerData.accesslevel || 'dealer');
    formData.append("dealerAddress", dealerData.address || '');
    formData.append("dealerCity", dealerData.city || '');
    formData.append("dealerState", dealerData.state || '');
    formData.append("dealerZipcode", dealerData.zipcode || '');
    if (dealerData.includeOffice) {
      formData.append("officeName", dealerData.officeName);
      formData.append("officeMobile1", dealerData.officeMobile1);
      formData.append("officeMobile2", dealerData.officeMobile2 || '');
      formData.append("officeemail", dealerData.officeemail);
      formData.append("officepassword", dealerData.officepassword);
      formData.append("officeaddress", dealerData.officeaddress || '');
      formData.append("city", dealerData.officeCity || '');
      formData.append("state", dealerData.officeState || '');
      formData.append("zipcode", dealerData.officeZipcode || '');
      formData.append("isbar", dealerData.isbar || '0');
      formData.append("officelicense", dealerData.officelicense || '');
    }
    
    console.log("FormData entries:");
    for (let pair of formData.entries()) {
      console.log(pair[0] + ': ' + pair[1]);
    }
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
      });
      
      const responseText = await response.text();
      console.log("Response status:", response.status);
      console.log("Response text:", responseText);
      
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status} - ${responseText}`);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = responseText;
      }
      return data;
    } catch (error) {
      console.error("Error adding dealer:", error);
      throw error;
    }
  },

  // Edit dealer (using FormData)
  editDealer: async (dealerId, dealerData) => {
    const url = `${API_BASE_URL}/cadealers/editdealer/${dealerId}`;
    console.log("Editing dealer at URL:", url);
    
    const formData = new FormData();
    formData.append("dealerName", dealerData.dealerName);
    formData.append("dealerEmail", dealerData.dealerEmail);
    formData.append("dealerMobile1", dealerData.dealerMobile1);
    formData.append("dealerMobile2", dealerData.dealerMobile2 || '');
    formData.append("accesslevel", dealerData.accesslevel || 'dealer');
    formData.append("dealerAddress", dealerData.address || '');
    formData.append("dealerCity", dealerData.city || '');
    formData.append("dealerState", dealerData.state || '');
    formData.append("dealerZipcode", dealerData.zipcode || '');
    
    if (dealerData.dealerPassword) {
      formData.append("dealerPassword", dealerData.dealerPassword);
    }
    
    console.log("FormData entries:");
    for (let pair of formData.entries()) {
      console.log(pair[0] + ': ' + pair[1]);
    }
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
      });
      
      const responseText = await response.text();
      console.log("Response status:", response.status);
      console.log("Response text:", responseText);
      
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status} - ${responseText}`);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = responseText;
      }
      return data;
    } catch (error) {
      console.error("Error editing dealer:", error);
      throw error;
    }
  },

  // Delete dealer
  deleteDealer: async (dealerId) => {
    const url = `${API_BASE_URL}/cadealers/deletedealer/${dealerId}`;
    console.log("Deleting dealer at URL:", url);
    
    try {
      const response = await fetch(url, {
        method: 'GET',
      });
      
      const responseText = await response.text();
      console.log("Response status:", response.status);
      console.log("Response text:", responseText);
      
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status} - ${responseText}`);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = responseText;
      }
      return data;
    } catch (error) {
      console.error("Error deleting dealer:", error);
      throw error;
    }
  },

  // Add office (using FormData)
  addOffice: async (officeData) => {
    const url = `${API_BASE_URL}/caoffices/addoffice`;
    console.log("Adding office at URL:", url);
    
    const formData = new FormData();
    formData.append("officeName", officeData.officeName);
    formData.append("officeMobile1", officeData.officeMobile1);
    formData.append("officeMobile2", officeData.officeMobile2 || '');
    formData.append("officeemail", officeData.officeemail);
    formData.append("officepassword", officeData.officepassword);
    formData.append("officeaddress", officeData.officeaddress);
    formData.append("city", officeData.city);
    formData.append("state", officeData.state);
    formData.append("zipcode", officeData.zipcode);
    formData.append("isbar", officeData.isbar);
    formData.append("officelicense", officeData.officelicense || '');
    formData.append("dealer", officeData.dealerId);
    
    console.log("FormData entries:");
    for (let pair of formData.entries()) {
      console.log(pair[0] + ': ' + pair[1]);
    }
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
      });
      
      const responseText = await response.text();
      console.log("Response status:", response.status);
      console.log("Response text:", responseText);
      
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status} - ${responseText}`);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = responseText;
      }
      return data;
    } catch (error) {
      console.error("Error adding office:", error);
      throw error;
    }
  },

  // Edit office (using FormData)
  editOffice: async (officeId, officeData) => {
    const url = `${API_BASE_URL}/caoffices/editoffice/${officeId}`;
    console.log("Editing office at URL:", url);
    
    const formData = new FormData();
    formData.append("officeName", officeData.officeName);
    formData.append("officeMobile1", officeData.officeMobile1);
    formData.append("officeMobile2", officeData.officeMobile2 || '');
    formData.append("officeemail", officeData.officeemail);
    formData.append("officepassword", officeData.officepassword);
    formData.append("officeaddress", officeData.officeaddress);
    formData.append("city", officeData.city);
    formData.append("state", officeData.state);
    formData.append("zipcode", officeData.zipcode);
    formData.append("isbar", officeData.isbar);
    formData.append("officelicense", officeData.officelicense || '');
    formData.append("dealer", officeData.dealerId);
    
    console.log("FormData entries:");
    for (let pair of formData.entries()) {
      console.log(pair[0] + ': ' + pair[1]);
    }
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
      });
      
      const responseText = await response.text();
      console.log("Response status:", response.status);
      console.log("Response text:", responseText);
      
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status} - ${responseText}`);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = responseText;
      }
      return data;
    } catch (error) {
      console.error("Error editing office:", error);
      throw error;
    }
  },

  // Delete office
  deleteOffice: async (officeId) => {
    const url = `${API_BASE_URL}/caoffices/deleteoffice/${officeId}`;
    console.log("Deleting office at URL:", url);
    
    try {
      const response = await fetch(url, {
        method: 'GET',
      });
      
      const responseText = await response.text();
      console.log("Response status:", response.status);
      console.log("Response text:", responseText);
      
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status} - ${responseText}`);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = responseText;
      }
      return data;
    } catch (error) {
      console.error("Error deleting office:", error);
      throw error;
    }
  },
};
